 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-01f1139b":"1d298d4a","chunk-0434f1c9":"328c133a","chunk-05c81fd8":"f7a3098d","chunk-069d623c":"fb66278d","chunk-096dd9be":"2ec8a76d","chunk-09b4743c":"f925920e","chunk-1061bfb8":"6387cc36","chunk-11b839fe":"16ba5957","chunk-09a66686":"229f3a03","chunk-b1357e9a":"50fee044","chunk-1a4cc034":"d2b2f546","chunk-154addf6":"1ff3199e","chunk-16a29b0a":"e3a63c99","chunk-16eb22bf":"388f44aa","chunk-18e7d5b7":"0588742e","chunk-1cae3b30":"afd6b39a","chunk-277b4af5":"bb38e904","chunk-2d0e140f":"8d7805c7","chunk-0fa209da":"f42c92e9","chunk-48c2a991":"948be4a6","chunk-d358a6ec":"e5f2a816","chunk-1b5552b7":"8a196fbb","chunk-1b6f7ff6":"25fa9067","chunk-66aa5048":"d417cd26","chunk-7cbf777f":"e0b93583","chunk-b591cdb4":"0aef9538","chunk-613f9063":"4f89d833","chunk-640ed9f1":"a5993403","chunk-7760d66a":"dd00acae","chunk-2d6669d0":"57b3aa20","chunk-33b2e1d2":"653c7e65","chunk-3b7e5cce":"b3f54497","chunk-3f8cd890":"8866623e","chunk-3fed8caa":"77963d3e","chunk-43fffcad":"00e1d9b6","chunk-8bf86320":"eae7ef93","chunk-d784b046":"553ea98c","chunk-4bcc3044":"34db19cf","chunk-4da3382c":"65ab8550","chunk-51787f6e":"07b1495f","chunk-52460f9c":"04f67b45","chunk-5463c3e6":"a0b4f4b2","chunk-59ca4dd0":"d53bbcba","chunk-61a06981":"a7b674fe","chunk-622e6f9e":"44c3389c","chunk-665adbe0":"9caacaf7","chunk-afcb8904":"143de50f","chunk-67e577a2":"9fcbcbcf","chunk-67ebd3a0":"3a19b0ac","chunk-14688fe5":"20523c69","chunk-2838dd31":"7a3f6289","chunk-3bc29563":"111ad809","chunk-699f73f1":"6bdb0633","chunk-729123ba":"83436b8c","chunk-731434c0":"5808359f","chunk-7adaedc0":"6c844707","chunk-7ff892ba":"356035b7","chunk-99061cbe":"60d50be5","chunk-9937e93e":"e1d008a9","chunk-cbf17334":"64c79fbc","chunk-365af53e":"178a7707","chunk-c182a89a":"81a86d74","chunk-d0bda3a6":"66cd43ad","chunk-d83e01e6":"6aaeeb5b","chunk-d9558900":"6069c647","chunk-da55143a":"ff49ac3c","chunk-dc3943a8":"d8b074a1","chunk-e66bcf9a":"70f88eda","chunk-e9309a3c":"6b47d7ab","chunk-f817072e":"88486b8c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01f1139b":1,"chunk-0434f1c9":1,"chunk-05c81fd8":1,"chunk-069d623c":1,"chunk-096dd9be":1,"chunk-09b4743c":1,"chunk-11b839fe":1,"chunk-09a66686":1,"chunk-b1357e9a":1,"chunk-1a4cc034":1,"chunk-154addf6":1,"chunk-16a29b0a":1,"chunk-16eb22bf":1,"chunk-18e7d5b7":1,"chunk-1cae3b30":1,"chunk-277b4af5":1,"chunk-0fa209da":1,"chunk-48c2a991":1,"chunk-d358a6ec":1,"chunk-1b5552b7":1,"chunk-1b6f7ff6":1,"chunk-7cbf777f":1,"chunk-b591cdb4":1,"chunk-613f9063":1,"chunk-640ed9f1":1,"chunk-7760d66a":1,"chunk-2d6669d0":1,"chunk-33b2e1d2":1,"chunk-3b7e5cce":1,"chunk-3f8cd890":1,"chunk-3fed8caa":1,"chunk-43fffcad":1,"chunk-8bf86320":1,"chunk-d784b046":1,"chunk-4bcc3044":1,"chunk-4da3382c":1,"chunk-51787f6e":1,"chunk-52460f9c":1,"chunk-5463c3e6":1,"chunk-59ca4dd0":1,"chunk-61a06981":1,"chunk-622e6f9e":1,"chunk-665adbe0":1,"chunk-afcb8904":1,"chunk-67e577a2":1,"chunk-67ebd3a0":1,"chunk-14688fe5":1,"chunk-2838dd31":1,"chunk-3bc29563":1,"chunk-699f73f1":1,"chunk-729123ba":1,"chunk-731434c0":1,"chunk-7adaedc0":1,"chunk-7ff892ba":1,"chunk-99061cbe":1,"chunk-9937e93e":1,"chunk-cbf17334":1,"chunk-365af53e":1,"chunk-c182a89a":1,"chunk-d0bda3a6":1,"chunk-d83e01e6":1,"chunk-da55143a":1,"chunk-e66bcf9a":1,"chunk-e9309a3c":1,"chunk-f817072e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01f1139b":"84add2ed","chunk-0434f1c9":"1afb1ad7","chunk-05c81fd8":"ffd7e113","chunk-069d623c":"edc3ee61","chunk-096dd9be":"fe9dbde3","chunk-09b4743c":"4e1d42eb","chunk-1061bfb8":"31d6cfe0","chunk-11b839fe":"b868c9af","chunk-09a66686":"67ad097f","chunk-b1357e9a":"3e96a622","chunk-1a4cc034":"dd8cff04","chunk-154addf6":"135c0e43","chunk-16a29b0a":"83726a48","chunk-16eb22bf":"63d7e759","chunk-18e7d5b7":"728e8c6e","chunk-1cae3b30":"c320a803","chunk-277b4af5":"e0c56e64","chunk-2d0e140f":"31d6cfe0","chunk-0fa209da":"448a6c63","chunk-48c2a991":"e5ef9801","chunk-d358a6ec":"49050fec","chunk-1b5552b7":"aa641e8c","chunk-1b6f7ff6":"f5966097","chunk-66aa5048":"31d6cfe0","chunk-7cbf777f":"7b4b790d","chunk-b591cdb4":"ebbbcf1e","chunk-613f9063":"92d8b44f","chunk-640ed9f1":"7cf35ec8","chunk-7760d66a":"077ac01e","chunk-2d6669d0":"7c46e050","chunk-33b2e1d2":"e9abaafe","chunk-3b7e5cce":"0fc907ca","chunk-3f8cd890":"72d827f4","chunk-3fed8caa":"3d706c24","chunk-43fffcad":"46d60b54","chunk-8bf86320":"aafecad4","chunk-d784b046":"c6623c0e","chunk-4bcc3044":"42d8a153","chunk-4da3382c":"e95fe0fb","chunk-51787f6e":"d00d2fc4","chunk-52460f9c":"1ba4a593","chunk-5463c3e6":"8ba87b8e","chunk-59ca4dd0":"bc507d23","chunk-61a06981":"0e56baee","chunk-622e6f9e":"05c5110b","chunk-665adbe0":"4f10da16","chunk-afcb8904":"01f45edd","chunk-67e577a2":"b0a269f5","chunk-67ebd3a0":"749727b9","chunk-14688fe5":"866158ae","chunk-2838dd31":"94e0bb3b","chunk-3bc29563":"c3c67120","chunk-699f73f1":"b86c5c6c","chunk-729123ba":"33477ecc","chunk-731434c0":"af92a3a9","chunk-7adaedc0":"41e5ddb6","chunk-7ff892ba":"0fc89efb","chunk-99061cbe":"c6dc0af9","chunk-9937e93e":"468a2f0e","chunk-cbf17334":"5dfbdc89","chunk-365af53e":"f8af52ed","chunk-c182a89a":"f6309a89","chunk-d0bda3a6":"fe339d7c","chunk-d83e01e6":"b77125ac","chunk-d9558900":"31d6cfe0","chunk-da55143a":"ca4e612f","chunk-dc3943a8":"31d6cfe0","chunk-e66bcf9a":"73c2a915","chunk-e9309a3c":"2c98444b","chunk-f817072e":"b16beb5d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://yijin-cdn.yjhlnews.cn/100003/ucenter/platform/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_ucp-cli3"] = window["webpackJsonp_ucp-cli3"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
